// v5.5 — Auth wall avec mode invité : si GUEST_MODE=on côté serveur, une session
// invitée est créée silencieusement (aucun formulaire) — l'app est testable sans SMS.
// Pour rétablir la page de connexion : retirer GUEST_MODE du backend/.env.
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const TOKEN_KEY = "civ_user_token";
const API = process.env.REACT_APP_BACKEND_URL || "";

let _guestPromise = null;
function ensureGuestSession() {
  if (!_guestPromise) {
    _guestPromise = (async () => {
      try {
        const cfg = await fetch(`${API}/api/auth/config`).then((r) => r.json());
        if (!cfg?.guest_mode) return false;
        const g = await fetch(`${API}/api/auth/guest`, { method: "POST" }).then((r) => r.json());
        if (g?.ok && g.token) {
          localStorage.setItem(TOKEN_KEY, g.token);
          localStorage.setItem("civ_is_guest", "1");
          return true;
        }
      } catch { /* réseau */ }
      return false;
    })();
  }
  return _guestPromise;
}

export default function RequireAuth({ children }) {
  const location = useLocation();
  const token = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
  const isGuest = typeof window !== "undefined" && localStorage.getItem("civ_is_guest") === "1";
  const [state, setState] = useState(token && !isGuest ? "ok" : "checking");

  useEffect(() => {
    if (token && !isGuest) return;
    let alive = true;
    if (token && isGuest) {
      // Session invitée existante : si le mode invité a été désactivé côté
      // serveur, on l'invalide pour ré-exiger le login OTP.
      fetch(`${API}/api/auth/config`).then((r) => r.json()).then((cfg) => {
        if (!alive) return;
        if (cfg?.guest_mode) { setState("ok"); return; }
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem("civ_is_guest");
        localStorage.removeItem("civ_user_profile");
        setState("login");
      }).catch(() => { if (alive) setState("ok"); });
      return () => { alive = false; };
    }
    ensureGuestSession().then((ok) => { if (alive) setState(ok ? "ok" : "login"); });
    return () => { alive = false; };
  }, [token, isGuest]);

  if (state === "ok") return children;
  if (state === "checking") return null;
  const next = encodeURIComponent(location.pathname + location.search);
  return <Navigate to={`/login?next=${next}`} replace />;
}
